import type { FrameRect, SpriteSheet } from './spriteLoader';

export function clearCanvas(ctx: CanvasRenderingContext2D, color = '#0E0C1A'): void {
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}

export function drawFrame(
  ctx: CanvasRenderingContext2D,
  sheet: SpriteSheet,
  frameIdx: number,
  dx: number,
  dy: number,
  flipX = false
): void {
  const f = sheet.frames[frameIdx];
  if (!f) return;
  if (flipX) {
    ctx.save();
    ctx.translate(dx + f.sw, dy);
    ctx.scale(-1, 1);
    ctx.drawImage(sheet.image, f.sx, f.sy, f.sw, f.sh, 0, 0, f.sw, f.sh);
    ctx.restore();
  } else {
    ctx.drawImage(sheet.image, f.sx, f.sy, f.sw, f.sh, dx, dy, f.sw, f.sh);
  }
}

export function drawText(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  opts?: { color?: string; size?: number; align?: CanvasTextAlign }
): void {
  ctx.fillStyle = opts?.color ?? '#FFFFFF';
  ctx.font = `${opts?.size ?? 8}px "Press Start 2P", monospace`;
  ctx.textAlign = opts?.align ?? 'left';
  ctx.textBaseline = 'top';
  ctx.fillText(text, x, y);
}

export function drawRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  color: string
): void {
  ctx.fillStyle = color;
  ctx.fillRect(x, y, w, h);
}
